/* assets/halo-faqs.js
   Loads safely even if the theme (or another section) tries
   to include it more than once. */

if (!customElements.get('faqs-item')) {
  class FAQs extends HTMLElement {
    constructor() {
      super();

      /* ---------- element look‑ups ---------- */
      this.filter      = document.getElementById('haloFAQsFilter');
      this.faqsPopup   = document.getElementById('halo-faqs-popup');

      /* ---------- filter drop‑down ---------- */
      if (this.filter) {
        this.filterToggle       = this.filter.querySelector('[data-faqs-filter]');
        this.filterDropdown     = this.filter.querySelector('.faqs-filterDropdown-menu');
        this.filterDropdownArrow= this.filterToggle.querySelector('[data-dropdown-arrow]');

        if (this.filterToggle) {
          this.filterToggle.addEventListener(
            'click',
            this.onClickFilterHandler.bind(this)
          );
        }

        this.filterDropdown
          .querySelectorAll('.text')
          .forEach((btn) =>
            btn.addEventListener(
              'click',
              this.onClickFilterButtonHandler.bind(this)
            )
          );
      }

      /* ---------- accordion headers ---------- */
      this.querySelectorAll('.card-header')
        .forEach((header) =>
          header.addEventListener(
            'click',
            this.onClickHeaderButtonHandler.bind(this)
          )
        );

      /* ---------- close drop‑down on body click (non‑home) ---------- */
      if (!document.body.classList.contains('template-index')) {
        document.body.addEventListener(
          'click',
          this.onBodyClickEvent.bind(this)
        );
      }
    }

    /* ===== filter toggle ===== */
    onClickFilterHandler() {
      this.filterDropdown.classList.toggle('is-show');
      this.filterDropdownArrow.classList.toggle('active');
    }

    /* ===== filter option selected ===== */
    onClickFilterButtonHandler(event) {
      const btn         = event.target.closest('li');
      const filterValue = btn.dataset.value;
      const filterText  = event.target.innerText;

      if (btn.classList.contains('is-active')) return;

      /* update toggle text & active state */
      this.filterToggle.querySelector('.text').innerText = filterText;
      this.filterDropdown
        .querySelectorAll('li')
        .forEach((el) => el.classList.remove('is-active'));
      btn.classList.add('is-active');

      /* show/hide faq paragraphs */
      this.querySelectorAll('.faqs-paragraph').forEach((el) => {
        const idMatch = el.id === filterValue || !filterValue;
        el.classList.toggle('is-hidden', !idMatch);
        el.classList.toggle('is-active', idMatch);
      });

      /* close drop‑down */
      this.filterDropdown.classList.remove('is-show');
      this.filterDropdownArrow.classList.remove('active');
    }

    /* ===== accordion header ===== */
    onClickHeaderButtonHandler(event) {
      const btn     = event.currentTarget;
      const content = btn.nextElementSibling;

      btn.classList.toggle('collapsed');
      content.style.maxHeight = content.style.maxHeight
        ? null
        : content.scrollHeight + 'px';
    }

    /* ===== body click (close filter) ===== */
onBodyClickEvent(event) {
  if (!this.filterDropdown) return;

  if (event.target.closest('[data-faqs-filter]')) return;

  if (this.filterDropdown.classList.contains('is-show')) {
    this.filterDropdown.classList.remove('is-show');
    this.filterDropdownArrow?.classList.remove('active');
  }
}

  }

  customElements.define('faqs-item', FAQs);
}
